export const BIN_ANIMATION_TIME = 1000;
export const ICON_REMOVE_ANIMATION_TIME = 500;
export const SHUTDOWN_TIME = 5000;
export const PROGRESS_BAR_INCREMENT_TIME = 100;
